function scrollsVertically(element: HTMLElement): boolean {
  const { overflowY } = window.getComputedStyle(element);
  return overflowY === "auto" || overflowY === "scroll";
}

function findVerticalScroller(el: HTMLElement): HTMLElement | null {
  let cur: HTMLElement | null = el;
  while (cur) {
    if (scrollsVertically(cur)) return cur;
    cur = cur.parentElement;
  }
  return null;
}

function offsetFromScrollerTop(scroller: HTMLElement, anchorElement: HTMLElement): number {
  return anchorElement.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
}

function restoreAnchorOffset(scroller: HTMLElement, anchorElement: HTMLElement, anchorOffsetBeforeResize: number): void {
  scroller.scrollTop += offsetFromScrollerTop(scroller, anchorElement) - anchorOffsetBeforeResize;
}

export function keepAnchorInPlaceThroughNextResize(anchorElement: HTMLElement, resizingElement: HTMLElement): void {
  const scroller = findVerticalScroller(anchorElement);
  if (scroller === null) return;
  const anchorOffsetBeforeResize = offsetFromScrollerTop(scroller, anchorElement);
  const resizeObserver = new ResizeObserver(() => {
    resizeObserver.disconnect();
    restoreAnchorOffset(scroller, anchorElement, anchorOffsetBeforeResize);
    requestAnimationFrame(() => restoreAnchorOffset(scroller, anchorElement, anchorOffsetBeforeResize));
  });
  resizeObserver.observe(resizingElement);
}
